module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/user-loading-56fd747778e1578a5112cca26875b9e7.png";